import React, { Component } from 'react';
import { connect } from 'react-redux';
import {getAdminDetails } from '../reducers/authReducer';
import { getModules } from 'src/reducers/commonReducer';
class OnBoarding extends Component {
  state = {
    isOnboarding: false,
    isGetOnboardingStatus: false,
  };
  componentDidMount() {
    this.getCustomerDetails()
  }
  getCustomerDetails = async () => {
    if (this.props.user) {
      this.props.getmemeberInfoa(this.props.user.sub.split('|')[1]);
      this.props.getAdminModules();
    }
  }
  render() {
    return (<div className="loader">Loading .....</div>)
  }
}
const connectStateToProps = ({ userConfig, oidc }) => {
  return { userConfig: userConfig.userProfileInfo, user: oidc.profile }
}
const connectDispatchToProps = dispatch => {
  return {
    getmemeberInfoa: (useremail) => {
      dispatch(getAdminDetails(useremail));
    },
    getAdminModules:()=>{
      dispatch(getModules());
    },
  }
}
export default connect(connectStateToProps, connectDispatchToProps)(OnBoarding);